import { render, staticRenderFns } from "./SharedDeckView.vue?vue&type=template&id=264f7142"
import script from "./SharedDeckView.vue?vue&type=script&lang=js"
export * from "./SharedDeckView.vue?vue&type=script&lang=js"
import style0 from "./SharedDeckView.vue?vue&type=style&index=0&id=264f7142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports